import React, { useState, useEffect } from 'react';
import * as S from './styles';
import dropdwnChangeOption from 'img/dropdown-change-option.svg';

const Dropdown = ({ label, placeholder, options, onChange, disable, value }: any) => {
  const [selected, setSelected] = useState<any>('');
  const [opened, setOpened] = useState(false);

  const list = options || [];

  const selectedOption = list?.find((option: any) => option.id === selected.id);
  useEffect(() => {
    onChange(selected);
  }, [selected, onChange]);

  useEffect(() => {
    disable && setOpened(false);
  }, [disable]);

  return (
    <S.Dropdown
      data-testid="dropdown-input"
      opened={list?.length !== 0 && opened}
      onClick={() => !disable && setOpened(!opened)}
      disable={disable}
    >
      <span>
        {label || (!selected && placeholder)}
        <img className="dropdwn-img" src={dropdwnChangeOption} alt="" />
      </span>
      <span className="selected">{selectedOption?.name}</span>
      {
        opened && (
          <div className="options">
            {
              list?.map((option: any, i: any) => (
                <div
                  key={i}
                  className="option"
                  onClick={() => {
                    setSelected(option);
                  }}
                  role="presentation"
                >
                  {option?.name}
                </div>
              ))
            }
          </div>
        )
      }
    </S.Dropdown>
  );
};

export default Dropdown;
